export const Footer = () => (
  <footer id="footer" className="footer">
    <div className="container">
      <div className="row gy-3">
        <div className="col-lg-3 col-md-6 d-flex">
          <i className="bi bi-geo-alt icon"></i>
          <div>
            <h4>Address</h4>
            <p>
              9510 Georgia ave <br />
              Silver Spring, MD 20902
              <br />
            </p>
          </div>
        </div>

        <div className="col-lg-3 col-md-6 footer-links d-flex">
          <i className="bi bi-telephone icon"></i>
          <div>
            <h4>Reservations</h4>
            <p>
              <strong>Phone:</strong> +12678881206
              <br />
              <strong>Email:</strong> 7starrwings@gmail.com
              <br />
            </p>
          </div>
        </div>

        <div className="col-lg-3 col-md-6 footer-links d-flex">
          <i className="bi bi-clock icon"></i>
          <div>
            <h4>Opening Hours</h4>
            <p>
              <strong>Mon-Sat: 11AM</strong> - 11PM
              <br />
              Sunday: Closed
            </p>
          </div>
        </div>

        <div className="col-lg-3 col-md-6 footer-links">
          <h4>Follow Us</h4>
          <div className="social-links d-flex">
            <a href="https://twitter.com/7starrwings" className="twitter">
              <i className="bi bi-twitter"></i>
            </a>
            <a href="https://facebook.com/7starrwings" className="facebook">
              <i className="bi bi-facebook"></i>
            </a>
            <a href="https://instagram.com/7starrwings" className="instagram">
              <i className="bi bi-instagram"></i>
            </a>
            <a href="https://linkedin.com/7starrwings" className="linkedin">
              <i className="bi bi-linkedin"></i>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div className="container">
      <div className="copyright">
        &copy; Copyright{" "}
        <strong>
          <span>7Starr Events</span>
        </strong>
        . All Rights Reserved
      </div>
      <div className="credits">
        {/*  All the links in the footer should remain intact.  */}
        {/*  You can delete the links only if you purchased the pro version.  */}
        {/*  Licensing information: https://bootstrapmade.com/license/  */}
        {/*  Purchase the pro version with working PHP/AJAX contact form: https://bootstrapmade.com/yummy-bootstrap-restaurant-website-template/  */}
        Designed by <a href="https://tenksolutions.com/">TenK Solutions, LLC</a>
      </div>
    </div>
  </footer>
);
